export const defaultErrorMessage = "An unexpected error occurred in the server";